"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceStatus = void 0;
exports.InvoiceStatus = {
    Unassigned: "UNASSIGNED",
    Draft: "DRAFT",
    New: "NEW",
    Approved: "APPROVED",
    Scheduled: "SCHEDULED",
    Pending: "PENDING",
    Paid: "PAID",
    Archived: "ARCHIVED",
    Refused: "REFUSED",
    Canceled: "CANCELED",
    Failed: "FAILED",
};
